import { PurchaseOrderFileType, WarehouseCheckInFileType } from "src/enums";
import { MimeType } from "src/types";

export class FileHelper {
  static getFileExtension(file: File) {
    return file.name.split(".").pop()?.toLowerCase();
  }
}

export function isInvalidFileType<T>(file: T, allowedTypes: MimeType[]): boolean {
  if (!(file instanceof File)) {
    return false;
  }
  const contentType = file.type.toLowerCase();
  return !allowedTypes.includes(contentType as MimeType);
}

export function isInvalidFileSize<T>(file: T): boolean {
  if (!(file instanceof File)) {
    return false;
  }
  return !(file.size <= 5 * 1024 * 1024);
}

export const isEqualFiles = (fileAArray: File[], filBeArray: File[]) =>
  fileAArray.length === filBeArray.length &&
  JSON.stringify(fileAArray.map((fileA) => [fileA.name, fileA.size, fileA.lastModified]).sort()) ===
    JSON.stringify(filBeArray.map((fileB) => [fileB.name, fileB.size, fileB.lastModified]).sort());

export function generateInvoicesZipFileName(): string {
  const datePart = new Date().toISOString().split("T")[0];
  return `Invoices_${datePart}.zip`;
}

export function generatePurchaseOrdersZipFileName(): string {
  const datePart = new Date().toISOString().split("T")[0];
  return `Orders_${datePart}.zip`;
}

export function generateTransitPurchaseOrdersZipFileName(): string {
  const datePart = new Date().toISOString().split("T")[0];
  return `Transit_Orders_${datePart}.zip`;
}

export const DEFAULT_ZIP_DOWNLOAD_NAME = "download.zip";

export const FILE_TYPE_SUFFIX = {
  [PurchaseOrderFileType.INVOICES]: "_Invoices.zip",
  [PurchaseOrderFileType.PACKING_LISTS]: "_Packing_Lists.zip",
  [PurchaseOrderFileType.COMPLIANCE]: "_Compliance_Documents.zip",
  [WarehouseCheckInFileType.CHECK_IN_IMAGES]: "_Images.zip"
} as const;
